/* eslint-disable no-extend-native */
/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import {
    createApp,
    computed,
    ref,
    reactive,
    onMounted,
} from 'vue/dist/vue.esm-bundler';

import { useStore } from 'vuex';
import VueToast from 'vue-toast-notification';
import Popper from 'vue3-popper';

import store from './frontendStore';
import employersfilter from './components/employersFilter.vue';
import contactform from './components/contactForm.vue';
import watchlistOverlay from './components/watchlistOverlay.vue';

import './styles/popper.css';

const app = createApp({
    components: {
        employersfilter,
        contactform,
        watchlistOverlay
    },
    setup() {
        // eslint-disable-next-line func-names
        String.prototype.slugify = function(separator = '-') {
            return this.toString()
                .normalize('NFD') // split an accented letter in the base letter and the acent
                .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
                .trim()
                .replace(/\s+/g, separator);
        };
        return {};
    },
});

app.use(store);
app.use(VueToast);
app.component('Popper', Popper); // Magic happens here

app.mount('#baytmFrontendApp');
